import React from "react";
import { Button, Input } from "../components/Form";
import { BiLogInCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import "./buttonflash.css";
import { useDispatch, useSelector } from "react-redux";
import { setAuthModalOpen } from "../redux/features/authModalSlice";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div
      className="w-full h-screen flex-colo bg-dry"
      style={{
        backgroundImage: `linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8)), url('/saigonstar/bghero.webp')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="flex flex-col items-center text-center px-4 py-8"
        onClick={() => dispatch(setAuthModalOpen(true))}
      >
        {/* Heading */}
        <h2 className="mt-4 text-[clamp(2.1rem,7vw,3rem)] font-semibold leading-tight text-center bg-gradient-to-tr from-[#fed693] to-[#ca7100] bg-clip-text text-transparent ">
          Saigon Star <br /> Vietnamese Cuisine
        </h2>
        <div className="border border-yellowlight w-16 m-4"></div>

        <div className="heroneon">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          Admin Login
        </div>
        <p className="text-text italic">Please login to continue</p>
      </div>
    </div>
  );
}

export default Login;
